export const NavigationLinkDefinitions = {
    CallEwaForAssistanceLinkCss:
        '!rounded-full !bg-neutral-200 !text-primary-600 !border-black',
    BluePhoneImageUrl: 'assets/svg/call_0884c2.svg',
} as const;
